import { KeycloakRoute } from '@europrocurement/l2d-keycloak';
import * as React from 'react';
import { Outlet } from 'react-router';

const TachesRoot = function () {
    return (
        <KeycloakRoute roles="realm:interne">
            <Outlet />
        </KeycloakRoute>
    );
};

export default TachesRoot;
